import {IImportService} from "./IImportService";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";
import { PrintClient } from "../entities/PrintClient";

export class PrintClientService extends BaseService<PrintClient>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, PrintClient);
    }
    protected getBaseUrl():string{
        return "printclient";
    }
    generateSecret():ng.IPromise<string> {
        var config:any = {};
        return this.useGetHandler("mqttclient","secret", config);
    }
    getAllExtended(): ng.IPromise<PrintClient[]> {
        var config: any = {};
        return this.useGetHandler(this.getBasesUrl(), "extended", config);
    }
}
